import copy from "copy-to-clipboard";
import {Message} from 'element-ui'
import { IframePostMessage } from '@/libs'

declare const window: any;

const FnPool: Function[] = [];
const FnPoolKey: string[] = [];

export class UtilService {

  static copy(dataStr: string) {
    if (copy(dataStr)) {
      Message.success("复制成功");
    } else {
      Message.error("复制失败");
    }
  }

  /**
   * 生成32位Guid
   * @returns {string}
   * @constructor
   */
   static Guid() {
    let timestamp = new Date().getTime();
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (timestamp + Math.random() * 16) % 16 | 0;
      timestamp = Math.floor(timestamp / 16);
      return (c === 'x' ? r : (r & 3 | 8)).toString(16);
    });
  }

  /**
   * 注册把函数注册成window函数
   * @param {Function} fn
   * @returns {string}
   * @constructor
   */
   static RegisterWinFunc(fn: Function,): string {
    const index = FnPool.indexOf(fn);
    if (~index) {
      return FnPoolKey[index];
    }
    const fnName = "Fn_" + this.Guid();
    FnPoolKey.push(fnName);
    FnPool.push(fn);
    window ? (window[fnName] = fn) : (window[fnName] = fn);
    return fnName;
  }

  static getUrlParamObj(wholeUrl: string) {
		let params: any = {};
		let url = wholeUrl ? wholeUrl : window.location.href;
		let queryParams = url.split("?");
		queryParams = Array.isArray(queryParams) && queryParams[1] ? queryParams[1] : "";
		let vars = queryParams.split("&");
		for (let i = 0; i < vars.length; i++) {
			let pair = vars[i].split("=");
			if (pair[0] != null && pair[0] !== "") {
				params[pair[0]] = pair[1];
			}
		}
		return params;
	}

  static GetIframeAgent() {
    return new Promise((resolve) => {
      let agent = { name: '', type: '' };
      const timeout = setTimeout(() => {
        console.log('IframeAgent', agent)
        resolve(agent);
      }, 600)
      window.parent.postMessage({
        key: IframePostMessage.NeIframeAgent,
      }, "*")
      const iframeMessage = function(value: any) {
        var iframeInitData = value.data || {};
        if (iframeInitData.key == IframePostMessage.NeIframeAgent && iframeInitData.data) {
          const { name, type } = iframeInitData.data;
          agent.name = name;
          agent.type = type;
        };
        window.removeEventListener('message', iframeMessage);
        clearTimeout(timeout);
        console.log('IframeAgent', agent)
        resolve(agent);
      }
      window.addEventListener('message', iframeMessage);
    })
  }

  /**
   * 不同格式转换日期
   * @param date
   * @returns {Date}
   * @constructor
   */
   static DateParse(date: any): Date {
    if (!(date instanceof Date)) {
      if (typeof date === "number") {
        date = new Date(date);
      } else if (typeof date === "string" && date !== "") {
        // if (~date.indexOf("T")) {
        //    // date = date.replace("T", " ");
        //   //return new Date(Date.parse(date));
        // }
        date = date.replace(/\..+$/g, "");
        if ((/\d{4}[^\d]\d{1,2}$/).test(date)) {
          date = date + "/01";
        }
        if ((/\d{4}[^\d]\d{1,2}[^\d]\d{1,2}$/).test(date)) {
          date = date + " 00:00:00";
        }
        //加时区转换，底座中不带时区获取事件会有问题
        if ((/\d{4}[^\d]\d{1,2}[^\d]\d{1,2}[^\d]\d{1,2}[^\d]\d{1,2}[^\d]\d{1,2}$/).test(date)) {
          date = date + "+0800";
        }
        date = date.replace(/(\d{4}[^\d]\d{1,2}[^\d]\d{1,2})[^\d](\d{1,2}[^\d]\d{1,2}[^\d]\d{1,2}(\+|\-)\d{4})$/, "$1T$2");
        //单数组前补充0
        date = date.replace(/(^|[^\d])(\d)(?=[^\d]|$)/ig, "$10$2");
        date = date.replace(/[^\d:+\-T ]/g, "-");
        date = new Date(date);

      }
    }
    return date;
  }

  /**
   * 日期格式化
   * @param date              要格式化的日期
   * @param {string} format   日期转换格式
   * @returns {String}
   * @constructor
   */
   static DateFormat(date: any, format: string = "yyyy-MM-dd"): string | any {
    if (!date) {
      return date;
    }
    if (typeof date === "string" && !date.trim()) {
      return "";
    }
    if (!format) {
      format = 'yyyy-MM-dd';
    }
    //修改为支持字符串格式的日期或date对象
    date = this.DateParse(date);

    let formats: any = {
      "y+": date.getFullYear(),
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "H+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "w+": ["日", "一", "二", "三", "四", "五", "六"][date.getDay()]
    };
    Object.keys(formats).forEach((key: string) => {
      const item = formats[key];
      format = format.replace(eval("/" + key + "/g"), function (exp) {
        return (exp.length === 1) ? (item) : (("0" + item).substr(("0" + item).length - exp.length));
      });
    });
    return format;
  }

  /**
   * 递归生成树形结构
   */
  static getTreeData(data: any[], pid: string | number, pidName: string = 'parentId', idName: string = 'id', childrenName: string = 'children') {
    let arr: any[] = [];
    for (let i = 0; i < data.length; i++) {
        if (data[i][pidName] == pid) {
            data[i].key = data[i][idName];
            data[i][childrenName] = this.getTreeData(data, data[i][idName], pidName, idName, childrenName);
            arr.push(data[i]);
        }
    }
    return arr;
  }

  static getFileExt(fileExt: string) {
    const fileExts = {
      'word': ['doc', 'docx', 'wps', 'rtf'],
      'excel': ['xls', 'xlsx', 'et'],
      'ppt': ['ppt', 'pptx', 'dps'],
      'txt': ['css','323','htm','html','stm','uls','bas','c','h','txt','rtx','sct','tsv','htt','htc','etx','vcf'],
      'zip': ['rar','zip','arj','gz','z','7z'],
      'music': ['au','snd','mid','rmi','mp3','aif','aifc','m3u','ra','ram','wav','wma','cda','flac','m4a','mid','mak','ra','wv','tta','dts'],
      'video': ['mp2','mp4','mpa','mpe','mpeg','mpg','mpv2','mov','mkv','3gp','dat','ogm','vob','rm','rmvb','ts','tp','ifo','nsv','qt','lsf','lsx','asf','asr','asx','avi','movie','wmv','avs','flv'],
      'image': ['bmp','cod','gif','jpe','jpeg','jpg','png','jfif','svg','tif','tiff','ras','cmx','ico','pnm','pbm','pgm','ppm','pic','tgb','xbm','xpm','xwd'],
      'pdf': ['pdf'],
      'exe': ['exe', 'com'],
      'sldprt': ['sldprt'],
      'sldasm': ['sldasm'],
      'catpart': ['catpart'],
      'catproduct': ['catproduct'],
      'prt': ['prt'],
      'asm': ['asm'],
      'par': ['par'],
      'ipt': ['ipt'],
      'iam': ['iam'],
      'z3': ['z3'],
      'igs': ['igs'],
      'iges': ['iges'],
      'step': ['step'],
      'stp': ['stp'],
      'dwg': ['dwg'],
      'dxf': ['dxf'],
      'drw': ['drw'],
      'slddrw': ['slddrw'],
      'catdrawing': ['catdrawing'],
      'dft': ['dft'],
      'idw': ['idw'],
      'exb': ['exb'],
      'fileDir': ['dir']
    };
    let fileExtStr = fileExt.substr(1);
    let img = 'default';
    //根据扩展名获取文件所属分类
    Object.keys(fileExts).forEach(function (item) {
      // @ts-ignore
      if (fileExts[item].includes(fileExtStr)) {
        img = item;
      }
    })
    return img;
  }

  static fileSizeFormat(bytes: number) {
    let size = '';
    if (bytes < 1024) {                            //小于1KB，则转化成B
      size = Math.floor(bytes * 100) / 100 + "B";
    } else if (bytes < 1024 * 1024) {            //小1MB，则转化成KB
      size = Math.floor((bytes / 1024) * 100) / 100 + "K";
    } else if (bytes < 1024 * 1024 * 1024) {        //小于1GB，则转化成MB
      size = Math.floor((bytes / (1024 * 1024)) * 100) / 100 + "M";
    } else {                                            //其他转化成GB
      size = Math.floor((bytes / (1024 * 1024 * 1024)) * 100) / 100 + "G";
    }
    return size;
  }

  /**
   * localStorage 存贮
   * 目前对象值如果是函数 、RegExp等特殊对象存贮会被忽略
   * @param { String } key  属性
   * @param { string } value 值
   */
  static localStorageSet = (key: string, value: any) => {
    if (typeof (value) === 'object') value = JSON.stringify(value);
    localStorage.setItem(key, value)
  };

  /**
   * localStorage 移除
   * @param {String} key  属性
   */
   static localStorageRemove = (key: string) => {
    localStorage.removeItem(key)
  };

  /**
   * localStorage 获取
   * @param {*} key 属性值
   */
  static localStorageGet = (key: string) => {
    let storageData = {};
    try {
      const storageObj: any = localStorage.getItem(key);
      storageData = JSON.parse(storageObj);
    } catch (e) {
      storageData = '';
    }
    return storageData ? storageData : "";
  };

  //过滤特殊字符 
  static SpecialCharacter = (value: string) => {
      value = value.replace(/\\/g , "＼");
      value = value.replace(/\//g , "╱");
      value = value.replace(/:/g , "：");
      value = value.replace(/\*/g , "×");
      value = value.replace(/\?/g , "？");
      value = value.replace(/\"/g , "”");
      value = value.replace(/</g , "＜");
      value = value.replace(/>/g  , "＞");
      value = value.replace(/\|/g , "丨");
      // value = value.replaceAll(" ", "");
      return value;
  }

  static returnJrzzComObj(value: { [x: string]: any; }) {
    const compKeysEnums: any = {
      companyId: 'CompID',
      companyMdt: 'CompMdt',
      companyName: 'CompName',
      companyLogo: 'CompLogo',
      province: 'Province',
      city: 'City',
      district: 'District',
      companyVipLevel: 'CompVipLevel',
    };
    const compKeysEnumsNew: any = {
      compId: 'CompID',
      compName: 'CompName',
      compLogo: 'CompLogo',
      vipLevel: 'CompVipLevel',
    };
    Object.keys(value).forEach(item => {
      if (value[item]) {
        value[compKeysEnums[item]] = value[item]
      }
    })
    Object.keys(value).forEach(item => {
      if (value[item]) {
        value[compKeysEnumsNew[item]] = value[item]
      }
    })
    return value;
  }

  /**
   * 根据关键词，高亮一段字符中的匹配文字
   * @param text 
   * @param content 
   * @returns 
   */
  static getHighLightHtml(text = '', content = '') {
    let endText = '';
    new Array(content.length).fill('').forEach((item, index) => {
      if (text.includes(content[index])) {
        endText = endText + `<em>${content[index]}</em>`
      } else {
        endText = endText + content[index];
      }
    })
    return endText;
  }

  /**
   * 防抖
   * @param {Function} Fn
   * @param {number} debounceTime
   * @returns {Function}
   * @constructor
   */

  static Debounce(Fn: Function, debounceTime: number = 200) {
    let timestamp: number = 0;
    let total = 0;
    return function (this: any, ...args: any[]) {
      timestamp = Date.now();
      total++;
      //防止并发操作的时候同时被调用，用index来判断是最后一次调用的
      setTimeout((_index: number) => {
        if (total !== _index) {
          return;
        }
        if (Date.now() < timestamp + debounceTime) {
          return;
        }
        Fn.apply(this, [...args, total]);
        total = 0;
      }, debounceTime, total);
    }
  }

  /**
   * 根据classname查找元素是否包含在指定元素内
   * @param childClass 
   * @param parentClass 
   * @returns 
   */
  static matchesSelector(childClass: string, parentClass: string){
    if (childClass == parentClass) return true;
    if (!childClass) return false;
    const element = (document as any).querySelector(`.${childClass}`);
    const selector = `.${parentClass} *`;
    if(element.matches){
      return element.matches(selector);
    } else if(element.matchesSelector){
      return element.matchesSelector(selector);
    } else if(element.webkitMatchesSelector){
      return element.webkitMatchesSelector(selector);
    } else if(element.msMatchesSelector){
      return element.msMatchesSelector(selector);
    } else if(element.mozMatchesSelector){
      return element.mozMatchesSelector(selector);
    } else if(element.oMatchesSelector){
      return element.oMatchesSelector(selector);
    }
  }
}
